import { createGlobalStyle } from 'styled-components'
import styledTheme from './theme'

const GlobalStyles = createGlobalStyle`
  html, body {
    height: 100%;
    width: 100%;
    max-width: 1600px;
    padding: 0;
    margin: 0 auto;
    color: #444;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: none;
  }

  body {
    margin: 0 auto;
    padding: 0;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: normal;

    a, a:link, a:hover, a:visited, a:active {
      color: ${styledTheme.colors.action_link};
    }
  }

  * {
    box-sizing: border-box;
  }

  #app {
    height: 100%;
  }

  span.nowrap {
    white-space: nowrap;
  }

  body.react-confirm-alert-body-element {
    overflow: hidden;
  }
  
  .react-confirm-alert-blur {
    filter: url(#gaussian-blur);
    filter: blur(2px);
    -webkit-filter: blur(2px);
  }
  
  .react-confirm-alert-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    background: rgb(110 110 110 / 45%);
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    justify-content: center;
    -ms-align-items: center;
    align-items: center;
    opacity: 0;
    -webkit-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;
    -moz-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;
    -o-animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;
    animation: react-confirm-alert-fadeIn 0.5s 0.2s forwards;
  }
  
  .react-confirm-alert-body {
    font-family: Arial, Helvetica, sans-serif;
    width: 400px;
    padding: 30px;
    text-align: left;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 20px 75px rgba(0, 0, 0, 0.13);
    color: #666;
  }
  
  .react-confirm-alert-svg {
    position: absolute;
    top: 0;
    left: 0;
  }
  
  .react-confirm-alert-body > h1 {
    margin-top: 0;
    font-size: 18px;
  }
  
  .react-confirm-alert-body > h3 {
    margin: 0;
    font-size: 16px;
  }
  
  .react-confirm-alert-button-group {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
  
  .react-confirm-alert-button-group > button {
    outline: none;
    background: #017e9c;
    border: none;
    display: inline-block;
    padding: 6px 18px;
    color: #eee;
    margin-right: 10px;
    border-radius: 5px;
    font-size: 14px;
    cursor: pointer;
  }
  
  @-webkit-keyframes react-confirm-alert-fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  
  @-moz-keyframes react-confirm-alert-fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  
  @-o-keyframes react-confirm-alert-fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  
  @keyframes react-confirm-alert-fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  

`

export default GlobalStyles